import React, { useEffect, useState } from "react";
import { Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import "./ApplyLeaveModal.scss";
import DatePicker from "react-datepicker";
import { CalenderIcon, TrashIcon } from "../../Icon";
import Select from "react-select";
import {
  ApplyLeaveDate,
  ApplyLeaveFormType,
} from "../../../commonTypes/stcoToolsType";
import moment from "moment";
import {
  calculatePreviousDate,
  currentDate,
  currentYear,
  daysBetween,
  formatDateInYear,
  getDatesInRange,
  reverseDate,
} from "../../../utils/commonFunctions";
import {
  FinacUsersType,
  LoginResponseType,
  UserProfileType,
} from "../../../redux/auth/authTypes";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import { GetAllFinacUserPayloadType, GetUserProfilePayload } from "../../../commonTypes/authTypes";
import {
  getAllFinacManagerAction,
  getAllFinacUsersAction,
  resetAuthError,
  resetAuthSuccess,
  resetFinacUsersList,
  resetSession,
  resetUserProfileAllData,
  userProfileAction,
} from "../../../redux/auth";
import useDebounce from "../../../customHooks/useDebounce";
import { CircularAvatar } from "../../commons";
import { components } from "react-select";
import {
  LeaveStatus,
  SingleWFHLeaveApplyDataType,
} from "../../../redux/stcoTools/stcoToolsType";
import { UploadFileIcon } from "../../../assets/images";
import {
  getMasterDataHolidayCalenderAction,
  resetHolidayCalenderList,
  resetMasterError,
  resetMasterMessage,
  resetMasterStatusCode,
  resetMasterSuccess,
} from "../../../redux/masterData";
import { GetHolidayCalenderPayloadType } from "../../../commonTypes/masterDataTypes";
import { HolidayCalenderListType } from "../../../redux/masterData/masterTypes";
import { BlobServiceClient } from "@azure/storage-blob";
import { ImageDataType } from "../../../commonTypes/fileManagerTypes";
import LeaveFileUpload from "./LeaveFileUpload";
import { SelctOptionType } from "../../DisbursementModule/DisbursementModuleForm/AddEditDisbursementForm";
type AppProps = {
  toggle: (data?: string) => void;
  isOpen: boolean;
  applyLeaveForm: ApplyLeaveFormType;
  setApplyLeaveForm: React.Dispatch<React.SetStateAction<ApplyLeaveFormType>>;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchResetFinacUsersList: () => void;
  finacUsersList: any;
  userFetching: boolean;
  token: string | null;
  dispatchResetSession: () => void;
  success: number | null;
  statusCode: number | null;
  error: string | null;
  dispatchResetAuthError: () => void;
  dispatchResetAuthSuccess: () => void;
   dispatchUserProfileData: (data: GetUserProfilePayload) => void;
   dispatchResetUserProfileAllData:()=>void;
  userProfileAllData: UserProfileType;
  finacManagerList: any;
  totalManagerCount: string | number;
  managerFetching: boolean;
  handleSubmitApplyOrWHF: () => void;
  isEdit: boolean;
  leaveBalance: number;
  workFromHomeStatus: number;
  weekdays: number | undefined;
  singleLeaveApply: SingleWFHLeaveApplyDataType;
  dateValidation: any;
  loginData: LoginResponseType;

  dispatchResetMasterDataHolidayCalenderListing: () => void;
  dispatchGetMasterDataHolidayCalenderAction: (
    data: GetHolidayCalenderPayloadType
  ) => void;
  holidayCalenderList: HolidayCalenderListType[] | [];
  employeeStatus: string;
  isType?: string | undefined;
};

type UserListType = {
  label: string;
  value: number | null;
};

export const LEAVE_TIME = [
  { label: "Full Day", value: "Full Day", duration_type: "Full Day" },
  { label: "First Half", value: "First Half", duration_type: "First Half" },
  { label: "Second Half", value: "Second Half", duration_type: "Second Half" },
];

const ApplyLeaveModal = ({
  toggle,
  isOpen,
  setApplyLeaveForm,
  applyLeaveForm,
  dispatchGetAllFinacUsersAction,
  dispatchResetFinacUsersList,
  finacUsersList,
  userFetching,
  token,
  dispatchResetSession,
  success,
  statusCode,
  error,
  userProfileAllData,
  dispatchResetAuthError,
  dispatchResetAuthSuccess,
  dispatchGetAllFinacManagerAction,
  finacManagerList,
  totalManagerCount,
  managerFetching,
  handleSubmitApplyOrWHF,
  isEdit,
  leaveBalance,
  weekdays,
  singleLeaveApply,
  dateValidation,
  loginData,
  dispatchResetMasterDataHolidayCalenderListing,
  dispatchGetMasterDataHolidayCalenderAction,
  holidayCalenderList,
  employeeStatus,
  isType,
  workFromHomeStatus,
  dispatchUserProfileData,
dispatchResetUserProfileAllData
}: AppProps) => {
  const defaultTeamMembersString =
    process.env.REACT_APP_DEFAULT_ACCESS_TEAMS_MEMBERS || "[]";
  const defaultUsers: SelctOptionType[] = JSON.parse(
    defaultTeamMembersString
  ) as SelctOptionType[];
  let startDateValidation = dateValidation;
  startDateValidation = startDateValidation?.map((el: any) => {
    return calculatePreviousDate(el, 1);
  });

  const [approverOffset, setApproverOffset] = useState(0);
  const [notifyOffset, setNotifyOffset] = useState(0);
  const [finalUserList, setFinalUserList] = useState<UserListType[] | []>([]);
  const [finalManagerUserList, setFinalManagerUserList] = useState<
    UserListType[] | []
  >([]);
  const [limit, setLimit] = useState(20);
  const [text, setText] = useState("");
  const [managerText, setManagerText] = useState("");
  const [loadCondition, setLoadCondition] = useState(true);
  const [holidays, setHolidays] = useState<string[]>([]);
  const [holidaysName, setHolidaysName] = useState<any>([]);
  const [files, setFiles] = useState<any>([]);
  const [userSelected, setUserSelected] = useState<UserListType[]>([
    defaultUsers[3],
    defaultUsers[4],
  ]);

  const [leaveBalanceData, setLeaveBalanceData] = useState(leaveBalance);
  const [WFHBalanceData, setWFHBalanceData] = useState(workFromHomeStatus);
  const [imageDetails, setImageDetails] = useState<ImageDataType>({
    imageUrl: "",
    downloadImage: "",
    fileType: "",
    finalFileName: "",
    updateBy: "",
    updatedAt: "",
  });
  const [totalDurationCount, setTotalDurationCount] = useState(0);
  let holidayDateValidation = holidays;
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;

  let blobSasUrl = `${blobBaseUrl}?${blobToken}`;

  const blobServiceClient = new BlobServiceClient(blobSasUrl);
  const containerName: any = process.env.REACT_APP_USER_CONTAINER_NAME;
  const containerClient = blobServiceClient.getContainerClient(containerName);
  const [uploadFetching, setUploadFetching] = useState(false);
  const uploadFiles = async (uploadedFile: any) => {
    const file = uploadedFile?.target?.files[0];
    try {
      setUploadFetching(true);
      let resp;
      const blockBlobClient = containerClient.getBlockBlobClient(
        new Date().valueOf() +
          "." +
          file.name.split(".")[file.name.split(".").length - 1]
      );
      resp = await blockBlobClient.uploadBrowserData(file);
      if (
        resp &&
        resp["_response"] &&
        resp["_response"].status &&
        (resp["_response"].status === 201 ||resp["_response"].status ===  200)
      ) {
        updateDocumentAPI(
          file.name,
          // file.id,
          blockBlobClient["_name"],
          blockBlobClient["_containerName"],
          file.type
        );
        setUploadFetching(false);
      } else {
        setUploadFetching(false);
        alert("something wrong");
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (isType === "Leave") {
      setApplyLeaveForm((prv: ApplyLeaveFormType) => {
        return {
          ...prv,
          type: 1,
        };
      });
    } else {
      setApplyLeaveForm((prv: ApplyLeaveFormType) => {
        return {
          ...prv,
          type: 2,
        };
      });
    }
  }, [isType]);

    useEffect(() => {
      if (token) {
        if (loginData.user_id) {
          let final_data = {
            token,
            user_id: loginData.user_id,
          };
          dispatchUserProfileData(final_data);
        }}},[])

  const getImageDetails = (data: any) => {
    setImageDetails({
      ...data,
      imageUrl: blobBaseUrl + data.file_url + "?" + blobToken,
      downloadImage: data.file_url,
      fileType: data.file_type,
      finalFileName: data.file_name,
    });
  };
  const updateDocumentAPI = (
    file_name: string,
    url_name: string,
    url_container: string,
    file_type: string
  ) => {
    let data: any = {
      file_name,
      file_url: url_container + "/" + url_name,
      file_type,
    };
    getImageDetails(data);
    if (files.length > 0) {
      setFiles((prevFiles: any) => [...prevFiles, data]);
    } else {
      setFiles([data]);
    }
  };

  const handleDeleteUploadedFile = (indexToDelete: number) => {
    const updatedFiles = files.filter(
      (_: any, index: number) => index !== indexToDelete
    );
    setFiles(updatedFiles);
  };

  holidayDateValidation = holidayDateValidation?.map((el: any) => {
    return calculatePreviousDate(el, 1);
  });

  function calculateTotalDuration(data: any[]): number {
    let totalDuration = 0;
    for (let item of data) {
      if (item.duration_type === "Full Day") {
        totalDuration += 1;
      } else {
        totalDuration += 0.5;
      }
    }
    return totalDuration;
  }

  const totalDuration = calculateTotalDuration(applyLeaveForm?.leave);

  useEffect(() => {
    setTotalDurationCount(() => totalDuration);
  }, [totalDuration]);

  useEffect(() => {
    setApplyLeaveForm((prv: ApplyLeaveFormType) => {
      return {
        ...prv,
        file_attachment: files,
      };
    });
  }, [files]);

  useEffect(() => {
    dispatchResetMasterDataHolidayCalenderListing();
    let finalData: GetHolidayCalenderPayloadType = {
      token,
      start_date: `01-01-${currentYear()}`,
      end_date: `31-12-${currentYear()}`,
      country: "India",
      sort_by: "date",
      sort_by_value: "desc",
      branch_id_filter:userProfileAllData?.hr_settings?.work_details
      ?.user_branch?._id
    };
    dispatchGetMasterDataHolidayCalenderAction(finalData);
  }, []);

  useEffect(() => {
    if (holidayCalenderList?.length) {
      let finalHolidayDates = holidayCalenderList?.map(
        (el: HolidayCalenderListType) => {
          return formatDateInYear(el?.date);
        }
      );
      let finalHolidayName = holidayCalenderList?.map(
        (el: HolidayCalenderListType) => {
          return {
            date: formatDateInYear(el?.date),
            holidayName: el?.description ? el?.description : "",
          };
        }
      );
      setHolidaysName(finalHolidayName);
      setHolidays(finalHolidayDates);
    } else {
      setHolidaysName([]);
      setHolidays([]);
    }
  }, [holidayCalenderList]);

  useEffect(() => {
    if (singleLeaveApply?.people_to_notify?.length > 0 && isEdit) {
      let totalUser = singleLeaveApply?.people_to_notify?.map((el: any) => {
        let firstName = el?.first_name ? el?.first_name : "";

        let lastName = el?.last_name ? el?.last_name : "";

        return {
          value: el?.user_id,
          label: firstName + " " + lastName,
        };
      });

      setUserSelected([...totalUser]);
    } else if (singleLeaveApply?.people_to_notify?.length === 0) {
      setUserSelected([]);
    }
    if (!isEdit) {
      setUserSelected([defaultUsers[3], defaultUsers[4]]);
    }
    if (isEdit && singleLeaveApply?.file_attachment) {
      setFiles((prevFiles: any) => [...singleLeaveApply?.file_attachment]);
    } else {
      setFiles([]);
    }
  }, [singleLeaveApply]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: approverOffset,
        limit,
        user_type: "manager",
        status: 1,
        search_term: text,
      };
      if (approverOffset <= +totalManagerCount) {
        dispatchGetAllFinacManagerAction(finalUserData);
      }
    }
  }, [approverOffset]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: notifyOffset,
        limit,
        user_type: "stco_users",
        status: 1,
        search_term: text,
      };
      if (notifyOffset <= finacUsersList?.total_count) {
        dispatchGetAllFinacUsersAction(finalUserData);
      }
    }
  }, [notifyOffset]);

  useEffect(() => {
    if (finacUsersList?.data?.length) {
      let finalUserData = finacUsersList?.data?.map((user: FinacUsersType) => {
        return {
          value: user?.user_id,
          label: `${user?.first_name ? user?.first_name : ""} ${
            user?.last_name ? user?.last_name : ""
          }%${user?.job_title ? user?.job_title : ""} ${
            user?.department ? "|" : ""
          } ${user?.department !== null ? user?.department : ""}`,
          image: user?.profile_pic?.file_url,
        };
      });
      if (notifyOffset > 0) {
        setFinalUserList([...finalUserList, ...finalUserData]);
      } else {
        setFinalUserList([...finalUserData]);
      }
    }
  }, [finacUsersList?.data]);
  
  useEffect(() => {
    if (!isEdit) {
      if (applyLeaveForm?.start_date && applyLeaveForm?.end_date) {
        let getRange: any = [];
        let daysBetweenGap = daysBetween(
          reverseDate(applyLeaveForm?.start_date),
          reverseDate(applyLeaveForm?.end_date)
        );
        if (employeeStatus === "Articleship" && daysBetweenGap > 29) {
          getRange = getDatesInRange(
            new Date(reverseDate(applyLeaveForm?.start_date)),
            new Date(reverseDate(applyLeaveForm?.end_date)),
            7,
            []
          );
        } else {
          getRange = getDatesInRange(
            new Date(reverseDate(applyLeaveForm?.start_date)),
            new Date(reverseDate(applyLeaveForm?.end_date)),
            weekdays,
            holidays
          );
        }
        if (getRange?.length) {
          let fillDateRangeData = getRange?.map((el: string, index: number) => {
            return {
              date: el,
              duration: "Full Day",
              duration_type: "Full Day",
              leave_type:
                applyLeaveForm?.type === 2
                  ? "WFH"
                  : leaveBalanceData >= index + 1 &&
                    (employeeStatus === "Full time" ||
                      employeeStatus === "Articleship")
                  ? "Casual Leave"
                  : leaveBalanceData >= totalDurationCount &&
                    (employeeStatus === "Full time" ||
                      employeeStatus === "Articleship")
                  ? "Casual Leave"
                  : (employeeStatus === "Full time" ||
                      employeeStatus === "Articleship") &&
                    leaveBalanceData <= totalDurationCount
                  ? "Unpaid Leave(full time)"
                  : "Unpaid Leave",
            };
          });

          setApplyLeaveForm((prv: ApplyLeaveFormType) => {
            return {
              ...prv,
              leave: fillDateRangeData,
            };
          });
        }
      } else {
        setApplyLeaveForm((prv: ApplyLeaveFormType) => {
          return {
            ...prv,
            leave: [],
          };
        });
      }
    }
    if (singleLeaveApply && Object.keys(singleLeaveApply)?.length && isEdit) {
      if (applyLeaveForm?.start_date && applyLeaveForm?.end_date) {
        const casualData = singleLeaveApply?.details?.filter(
          (el: any) => el?.leave_type === "Casual Leave"
        );
        const wfh = singleLeaveApply?.details?.filter(
          (el: any) => el?.leave_type === "WFH"
        );

        let pendingData = 0;
        let pendingWFH = 0;
        if (casualData?.length) {
          pendingData = casualData.reduce(
            (total: number, entry: any) => total + entry.duration,
            0
          );
        }
        if (wfh?.length) {
          pendingWFH = wfh.reduce(
            (total: number, entry: any) => total + entry.duration,
            0
          );
        }
        setLeaveBalanceData(leaveBalance + pendingData);
        setWFHBalanceData(workFromHomeStatus + pendingWFH);
        //Articleship in edit

        // let getRange = getDatesInRange(
        //   new Date(reverseDate(applyLeaveForm?.start_date)),
        //   new Date(reverseDate(applyLeaveForm?.end_date)),
        //   weekdays,
        //   holidays
        // );
        let getRange: any = [];
        let daysBetweenGap = daysBetween(
          reverseDate(applyLeaveForm?.start_date),
          reverseDate(applyLeaveForm?.end_date)
        );

        if (employeeStatus === "Articleship" && daysBetweenGap > 29) {
          getRange = getDatesInRange(
            new Date(reverseDate(applyLeaveForm?.start_date)),
            new Date(reverseDate(applyLeaveForm?.end_date)),
            7,
            []
          );
        } else {
          getRange = getDatesInRange(
            new Date(reverseDate(applyLeaveForm?.start_date)),
            new Date(reverseDate(applyLeaveForm?.end_date)),
            weekdays,
            holidays
          );
        }
        let fillDateRangeData: any[] = [];
        if (
          (getRange?.length &&
            singleLeaveApply?.end_date !== applyLeaveForm?.end_date) ||
          singleLeaveApply?.start_date !== applyLeaveForm?.start_date
        ) {
          fillDateRangeData = getRange?.map((el: string, index: number) => {
            return {
              date: el,
              duration: "Full Day",
              duration_type: "Full Day",
              leave_type:
                applyLeaveForm?.type === 2
                  ? "WFH"
                  : leaveBalanceData >= totalDuration &&
                    employeeStatus === "Full time"
                  ? "Casual Leave"
                  : employeeStatus === "Full time" &&
                    leaveBalanceData < totalDuration
                  ? "Unpaid Leave(full time)"
                  : "Unpaid Leave",
            };
          });
        } else {
          if (singleLeaveApply?.details?.length) {
            fillDateRangeData = singleLeaveApply?.details?.map(
              (el: any, index: number) => {
                return {
                  date: el?.date,
                  duration: el?.duration,
                  duration_type: el?.duration_type,
                  leave_type:
                    applyLeaveForm?.type === 2
                      ? "WFH"
                      : leaveBalanceData >= totalDuration &&
                        employeeStatus === "Full time"
                      ? "Casual Leave"
                      : employeeStatus === "Full time" &&
                        leaveBalanceData < totalDuration
                      ? "Unpaid Leave(full time)"
                      : "Unpaid Leave",
                };
              }
            );

            // fillDateRangeData = [...singleLeaveApply?.details];
          }
        }
        if (singleLeaveApply?.details?.length) {
          setApplyLeaveForm((prv: ApplyLeaveFormType) => {
            return {
              ...prv,
              leave: fillDateRangeData,
            };
          });
        }
      } else {
        setApplyLeaveForm((prv: ApplyLeaveFormType) => {
          return {
            ...prv,
            leave: [],
          };
        });
      }
    }
  }, [
    applyLeaveForm?.start_date,
    applyLeaveForm?.end_date,
    singleLeaveApply,
    leaveBalanceData,
    workFromHomeStatus,
  ]);

  useEffect(() => {
    if (applyLeaveForm?.leave?.length) {
      let sum = 0;
      let fillDateRangeData = applyLeaveForm?.leave?.map(
        (el: any, index: number) => {
          if (el?.duration_type === "Full Day") {
            sum += 1;
          } else {
            sum += 0.5;
          }
          return {
            ...el,
            leave_type:
              applyLeaveForm?.type === 2
                ? "WFH"
                : leaveBalanceData >= sum &&
                  (employeeStatus === "Full time" ||
                    employeeStatus === "Articleship")
                ? "Casual Leave"
                : leaveBalanceData >= totalDurationCount &&
                  (employeeStatus === "Full time" ||
                    employeeStatus === "Articleship")
                ? "Casual Leave"
                : (employeeStatus === "Full time" ||
                    employeeStatus === "Articleship") &&
                  leaveBalanceData <= totalDurationCount
                ? "Unpaid Leave(full time)"
                : "Unpaid Leave",
          };
        }
      );

      setApplyLeaveForm((prv: ApplyLeaveFormType) => {
        return {
          ...prv,
          leave: fillDateRangeData,
        };
      });
    }
  }, [totalDurationCount]);

  useDebounce(
    () => {
      if (text) {
        fetchNewData(text);
      } else {
        const finalData = {
          token,
          offset: approverOffset,
          limit,
          user_type: "stco_users",
          status: 1,
          search_term: text,
        };
        dispatchGetAllFinacUsersAction(finalData);
      }
    },
    500,
    [text]
  );

  const fetchNewData = (search: string) => {
    const finalData = {
      token,
      offset: approverOffset,
      limit,
      user_type: "stco_users",
      status: 1,
      search_term: text,
    };
    dispatchGetAllFinacUsersAction(finalData);
  };

  const checkBottomManager = (e: any) => {
    setApproverOffset((prv: any) => prv + limit);
  };
  const checkBottomUsers = (e: any) => {
    setNotifyOffset((prv: any) => prv + limit);
  };

  ////manager
  useEffect(() => {
    if (finacManagerList?.length) {
      const data = finacManagerList?.filter(
        (e: any) => e?.user_id !== loginData?.user_id
      );

      let finalManageUserData = data?.map((user: FinacUsersType) => {
        return {
          value: user?.user_id,
          label: `${user?.first_name ? user?.first_name : ""} ${
            user?.last_name ? user?.last_name : ""
          }%${user?.job_title ? user?.job_title : ""} ${
            user?.department ? "|" : ""
          } ${user?.department !== null ? user?.department : ""}`,
          image: user?.profile_pic?.file_url,
        };
      });
      if (approverOffset > 0) {
        setFinalManagerUserList([
          ...finalManagerUserList,
          ...finalManageUserData,
        ]);
      } else {
        setFinalManagerUserList([...finalManageUserData]);
      }
    }
  }, [finacManagerList]);

  useDebounce(
    () => {
      if (managerText) {
        fetchNewManagerData(managerText);
      } else {
        const finalData = {
          token,
          offset: notifyOffset,
          limit: limit,
          user_type: "manager",
          status: 1,
          search_term: managerText,
        };
        dispatchGetAllFinacManagerAction(finalData);
      }
    },
    500,
    [managerText]
  );

  const fetchNewManagerData = (search: string) => {
    const finalData = {
      token,
      offset: notifyOffset,
      limit: limit,
      user_type: "manager",
      status: 1,
      search_term: managerText,
    };
    dispatchGetAllFinacManagerAction(finalData);
  };

  const handleLeaveFromChange = (data: any) => {
    if (data) {
      setApplyLeaveForm((prv: ApplyLeaveFormType) => {
        return {
          ...prv,
          start_date: moment(data).format("DD-MM-YYYY"),
          end_date: "",
        };
      });
    } else {
      setApplyLeaveForm((prv: ApplyLeaveFormType) => {
        return {
          ...prv,
          start_date: "",
        };
      });
    }
  };

  const handleLeaveToChange = (data: any) => {
    if (data) {
      setApplyLeaveForm((prv: ApplyLeaveFormType) => {
        return {
          ...prv,
          end_date: moment(data).format("DD-MM-YYYY"),
        };
      });
    } else {
      setApplyLeaveForm((prv: ApplyLeaveFormType) => {
        return {
          ...prv,
          end_date: "",
        };
      });
    }
  };

  const onMenuClose = () => {
    setLoadCondition(true);
  };

  const handleChange = (e: any) => {
    const userIds: number[] = [];
    let totalUser = e?.map((e: any) => {
      let userName = e?.label?.split("%")[0];
      userIds.push(e?.value);
      return {
        value: e?.value,
        label: userName,
      };
    });

    setUserSelected(totalUser);
    setApplyLeaveForm((prv: ApplyLeaveFormType) => {
      return {
        ...prv,
        people_to_notify: userIds,
      };
    });
  };

  const handleReasonChange = (data: any) => {
    if (data) {
      setApplyLeaveForm((prv: ApplyLeaveFormType) => {
        return {
          ...prv,
          reason: data?.target?.value,
        };
      });
    } else {
      setApplyLeaveForm((prv: ApplyLeaveFormType) => {
        return {
          ...prv,
          reason: "",
        };
      });
    }
  };

  const handleApproverChange = (e: any) => {
    let userName = e?.label?.split("%")[0];
    setApplyLeaveForm((prv: ApplyLeaveFormType) => {
      return {
        ...prv,
        approved_by: { label: userName, value: e?.value },
      };
    });
  };

  const Option = (props: any) => {
    const { data } = props;

    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };

  const handleChangeLeaveDetails = (data: any, index: number) => {
    // let finalArray = applyLeaveForm?.leave?.map(
    //   (el: ApplyLeaveDate, ind: number) => {
    //     if (ind === index) {
    //       applyLeaveForm.leave[index]["duration"] = data?.value;
    //       applyLeaveForm.leave[index]["duration_type"] = data?.duration_type;
    //     }
    //     return el;
    //   }
    // );
    let finalArray = applyLeaveForm?.leave?.map(
      (el: ApplyLeaveDate, ind: number) => {
        if (ind === index) {
          return {
            ...el,
            duration: data?.value,
            duration_type: data?.duration_type,
          };
        }
        return el;
      }
    );

    setApplyLeaveForm((prv: ApplyLeaveFormType) => {
      return {
        ...prv,
        leave: finalArray,
      };
    });
  };

  let previousWeekDate = calculatePreviousDate(
    new Date(currentDate()).toString(),
    7
  );
  return (
    <Modal
      centered
      isOpen={isOpen}
      toggle={() => toggle("close")}
      size="lg"
      style={{ minWidth: "70vw", minHeight: "677px" }}
      backdrop="static"
    >
      <ModalHeader
        className="pt-3 pl-4"
        id="cross-cut"
        toggle={() => toggle("close")}
        style={{ paddingBottom: "13px", border: "none" }}
      >
        {!isEdit && isType && isType === "Leave"
          ? `Apply New Leave`
          : isType && isType === "Leave"
          ? `Edit Leaves`
          : !isEdit && isType && isType === "WFH"
          ? "Apply Work From Home"
          : "Edit Work From Home "}
      </ModalHeader>
      <ModalBody className="pt-2" style={{ padding: "0px", minHeight: "70vh" }}>
        <div className="d-flex apply-box-content">
          <div className="p-3" style={{ overflow: "auto" }}>
            <div
              style={{ color: "#6e7491", fontSize: "15px", fontWeight: 500 }}
            >
              Fill form below to apply for a{" "}
              {isType && isType === "Leave" ? "Leave" : "work from home"}
            </div>
            <div className="mt-2">
              <span
                style={{
                  borderRadius: "16px",
                  // background: leaveBalanceData === 0 ? "#fde0d3" : "#e7f0d4",
                  // color: leaveBalanceData === 0 ? "#e7733e" : "#82b01f",
                }}
                className={
                  isType === "Leave" && leaveBalanceData === 0
                    ? `status-incomplete`
                    : isType === "WFH" && workFromHomeStatus === 0
                    ? `status-incomplete`
                    : `status-complete`
                }
              >
                {isType && isType === "Leave"
                  ? `Leave Balance = ${leaveBalanceData}`
                  : `WFH Balance = ${WFHBalanceData}`}
              </span>
            </div>

            <div className="row mt-2">
              <div className="col-md-6">
                <label htmlFor="dateOfBirth">
                  {isType === "Leave" ? (
                    <>
                      Leave From <span className="color-red">*</span>
                    </>
                  ) : (
                    <>
                      Start From <span className="color-red">*</span>
                    </>
                  )}
                </label>
                <div className="d-flex flex-row position-relative">
                  <div className="date-picker-wraper mr-0 w-100">
                    <Label className="mr-0 w-100">
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        onChange={(e: any) => handleLeaveFromChange(e)}
                        fixedHeight
                        name="start_date"
                        placeholderText="Select"
                        holidays={holidaysName}
                        className="form-control"
                        // minDate={new Date(currentDate())}
                        minDate={new Date(previousWeekDate)}
                        maxDate={new Date(new Date().getFullYear(), 11, 31)}
                        filterDate={(date) => {
                          const formattedDate = date
                            .toISOString()
                            .split("T")[0];
                          if (weekdays === 5) {
                            if (date.getDay() === 0 || date.getDay() === 6) {
                              return false;
                            }
                          } else {
                            if (date.getDay() === 0) {
                              return false;
                            }
                          }
                          if (holidayDateValidation?.includes(formattedDate)) {
                            return false;
                          }

                          if (startDateValidation?.includes(formattedDate)) {
                            return false;
                          }

                          return true;
                        }}
                        selected={
                          applyLeaveForm?.start_date
                            ? new Date(
                                moment(
                                  `${applyLeaveForm?.start_date}T00:00:00`,
                                  "DD-MM-YYYY"
                                ).format("YYYY-MM-DD[T]HH:mm:ss")
                              )
                            : null
                        }
                      />
                      <span
                        className="calender-icon"
                        style={{
                          right: "20px",
                          top: "10px",
                          cursor: "pointer",
                        }}
                      >
                        <CalenderIcon />
                      </span>
                    </Label>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <label htmlFor="dateOfBirth">
                  {isType === "Leave" ? (
                    <>
                      Leave To <span className="color-red">*</span>
                    </>
                  ) : (
                    <>
                      End To <span className="color-red">*</span>
                    </>
                  )}
                </label>
                <div className="d-flex flex-row position-relative">
                  <div className="date-picker-wraper mr-0 w-100">
                    <Label className="mr-0 w-100">
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        onChange={(e: any) => handleLeaveToChange(e)}
                        fixedHeight
                        name="start_date"
                        placeholderText="Select"
                        className="form-control"
                        holidays={holidaysName}
                        filterDate={(date) => {
                          // Format the date in 'YYYY-MM-DD' format
                          const formattedDate = date
                            .toISOString()
                            .split("T")[0];
                          if (weekdays === 5) {
                            if (date.getDay() === 0 || date.getDay() === 6) {
                              return false; // Disable weekends
                            }
                          } else {
                            if (date.getDay() === 0) {
                              return false; // Disable Sundays
                            }
                          }
                          if (holidayDateValidation?.includes(formattedDate)) {
                            return false;
                          }

                          const nextBiggerDate = dateValidation?.find(
                            (date: any) =>
                              new Date(date) >
                              new Date(reverseDate(applyLeaveForm?.start_date))
                          );

                          if (startDateValidation?.includes(formattedDate)) {
                            return false;
                          }
                          if (nextBiggerDate) {
                            return formattedDate < nextBiggerDate;
                          }

                          return true;
                        }}
                        minDate={
                          new Date(currentDate()) || applyLeaveForm?.start_date
                            ? new Date(
                                moment(
                                  `${applyLeaveForm?.start_date}T00:00:00`,
                                  "DD-MM-YYYY"
                                ).format("YYYY-MM-DD[T]HH:mm:ss")
                              )
                            : null
                        }
                        maxDate={new Date(new Date().getFullYear(), 11, 31)}
                        selected={
                          applyLeaveForm?.end_date
                            ? new Date(
                                moment(
                                  `${applyLeaveForm?.end_date}T00:00:00`,
                                  "DD-MM-YYYY"
                                ).format("YYYY-MM-DD[T]HH:mm:ss")
                              )
                            : null
                        }
                        disabled={!applyLeaveForm?.start_date}
                      />
                      <span
                        className="calender-icon"
                        style={{
                          right: "20px",
                          top: "10px",
                          cursor: "pointer",
                        }}
                      >
                        <CalenderIcon />
                      </span>
                    </Label>
                  </div>
                </div>
              </div>
            </div>
            <div>
              {" "}
              {isType === "WFH" && WFHBalanceData < totalDuration ? (
                <div className="text-danger mt-2" style={{ fontSize: "12px" }}>
                  {/* Note: Your work from home balance is insufficient, kindly
                  manage the dates accordingly. */}
                </div>
              ) : (
                <div></div>
              )}
            </div>
            <div className="row mt-2">
              <div className="col-md-6">
                <label htmlFor="Approver" className="mb-1">
                  Approver <span className="color-red">*</span>
                </label>

                <Select
                  options={finalManagerUserList}
                  onMenuScrollToBottom={(e: any) => checkBottomManager(e)}
                  onChange={(e) => handleApproverChange(e)}
                  onInputChange={(e: string) => {
                    setLoadCondition(false);
                    setManagerText(e);
                    setApproverOffset(0);
                  }}
                  components={{ Option }}
                  onMenuClose={onMenuClose}
                  isSearchable={true}
                  isLoading={managerFetching}
                  value={applyLeaveForm?.approved_by}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="People to Notify" className="mb-1">
                  People to Notify
                </label>

                <Select
                  options={finalUserList}
                  onChange={handleChange}
                  onMenuScrollToBottom={(e: any) => checkBottomUsers(e)}
                  isSearchable={true}
                  isLoading={userFetching}
                  isMulti
                  isClearable
                  components={{ Option }}
                  onInputChange={(e: string) => {
                    setLoadCondition(false);
                    setText(e);
                    setNotifyOffset(0);
                  }}
                  onMenuClose={onMenuClose}
                  value={userSelected[0]?.label ? userSelected : []}
                />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-12">
                <label htmlFor="Reason" className="mb-1">
                  Reason <span className="color-red">*</span>
                </label>
                <div className="d-flex flex-row position-relative">
                  <textarea
                    className="form-control"
                    name="reason"
                    style={{ height: "115px", resize: "none" }}
                    onChange={handleReasonChange}
                    value={applyLeaveForm?.reason}
                  ></textarea>
                </div>
              </div>
            </div>
            {isType && isType === "Leave" ? (
              <div className="ml-2" style={{ width: "28%" }}>
                <LeaveFileUpload
                  uploadFiles={uploadFiles}
                  files={files}
                  handleDeleteUploadedFile={handleDeleteUploadedFile}
                  uploadFetching={uploadFetching}
                />
                <div>{uploadFetching ? `loading...` : ""}</div>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="p-4" style={{ overflow: "auto" }}>
            {applyLeaveForm?.leave?.length ? (
              <div className="d-flex">
                <div style={{ fontSize: "17px", fontWeight: 500 }}>
                  {isType === "Leave" ? "Leave Details" : "WFH Details"}
                </div>
                <div className="manufacturing-journal ml-4">
                  {totalDuration} Days
                </div>
              </div>
            ) : (
              ""
            )}

            {applyLeaveForm?.leave?.length &&
            leaveBalanceData &&
            isType &&
            isType === "Leave" ? (
              <>
                {!!applyLeaveForm?.leave?.filter(
                  (el: ApplyLeaveDate) => el?.leave_type === "Casual Leave"
                )?.length && (
                  <div
                    style={{ fontSize: "15px", fontWeight: 500 }}
                    className="mt-2"
                  >
                    Casual Leave
                  </div>
                )}
              </>
            ) : applyLeaveForm?.leave?.length &&
              WFHBalanceData &&
              isType === "WFH" ? (
              <div
                style={{ fontSize: "15px", fontWeight: 500 }}
                className="mt-2"
              >
                WFH
              </div>
            ) : (
              ""
            )}
            <div className="mt-3">
              {applyLeaveForm?.leave?.length
                ? applyLeaveForm?.leave?.map(
                    (el: ApplyLeaveDate, index: number) => {
                      if (el?.leave_type === "Casual Leave") {
                        return (
                          <div className="apply-date-range-container mb-3">
                            <div>{el?.date}</div>
                            <div className="w-50 ml-4">
                              <Select<any, false>
                                inputProps={{ autoComplete: "nope" }}
                                placeholder={"Select..."}
                                options={LEAVE_TIME}
                                value={{
                                  label:
                                    (el?.duration === 1 ||
                                      el?.duration === "Full Day") &&
                                    el?.duration_type === "Full Day"
                                      ? "Full Day"
                                      : (el?.duration === 0.5 ||
                                          el?.duration === "First Half") &&
                                        el?.duration_type === "First Half"
                                      ? "First Half"
                                      : "Second Half",
                                  value: el?.duration,
                                }}
                                onChange={(e: any) => {
                                  if (e) {
                                    handleChangeLeaveDetails(e, index);
                                  }
                                }}
                              />
                            </div>
                          </div>
                        );
                      }
                    }
                  )
                : ""}

              {applyLeaveForm?.leave?.length &&
              isType === "Leave" &&
              leaveBalanceData < totalDuration ? (
                <div
                  style={{ fontSize: "15px", fontWeight: 500 }}
                  className="mt-2 mb-2"
                >
                  Unpaid Leave
                </div>
              ) : (
                ""
              )}
              {applyLeaveForm?.leave?.length
                ? applyLeaveForm?.leave?.map(
                    (el: ApplyLeaveDate, index: number) => {
                      // if (casualLaveSum > leaveBalanceData)
                      if (el?.leave_type !== "Casual Leave") {
                        return (
                          <div className="apply-date-range-container mb-3">
                            <div>{el?.date}</div>
                            <div className="w-50 ml-4">
                              <Select<any, false>
                                inputProps={{ autoComplete: "nope" }}
                                placeholder={"Select..."}
                                options={LEAVE_TIME}
                                value={{
                                  label:
                                    (el?.duration === 1 ||
                                      el?.duration === "Full Day") &&
                                    el?.duration_type === "Full Day"
                                      ? "Full Day"
                                      : (el?.duration === 0.5 ||
                                          el?.duration === "First Half") &&
                                        el?.duration_type === "First Half"
                                      ? "First Half"
                                      : "Second Half",
                                  value: el?.duration,
                                }}
                                onChange={(e: any) => {
                                  if (e) {
                                    handleChangeLeaveDetails(e, index);
                                  }
                                }}
                              />
                            </div>
                          </div>
                        );
                      }
                    }
                  )
                : ""}
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter
        style={{
          border: "none",
          margin: 0,
          display: "flex",
        }}
      >
        <div className="d-flex justify-content-end w-100 align-items-center">
          <div>
            <button
              className="btn"
              style={{ border: "1px solid #bfcbe1", marginRight: "15px" }}
              onClick={() => toggle("")}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              disabled={
                !applyLeaveForm?.start_date ||
                !applyLeaveForm?.end_date ||
                !applyLeaveForm?.reason ||
                !applyLeaveForm?.approved_by?.value ||
                // (!!leaveBalance &&
                //   leaveBalance !== 0 &&
                //   leaveBalance < totalDuration)
                (isType === "WFH" && WFHBalanceData < totalDuration)
              }
              onClick={handleSubmitApplyOrWHF}
            >
              {isEdit && isType === "Leave"
                ? "Edit Apply Leave"
                : isType === "Leave"
                ? "Apply Leave"
                : isEdit
                ? "Edit WFH"
                : "Apply WFH"}
            </button>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state: RootState) => ({
  userFetching: state.auth.fetching,
  userProfileAllData: state.auth.userProfileAllData,
  token: state.auth.token,
  success: state.auth.success,
  error: state.auth.error,
  finacUsersList: state.auth.finacUsersList,
  finacManagerList: state.auth.finacManagerList,
  statusCode: state.auth.statusCode,
  loginData: state.auth.loginData,
  managerFetching: state.auth.managerFetching,
  totalManagerCount: state.auth.totalManagerCount,
  holidayCalenderList: state.masterData.holidayCalenderList,
  holidayFetching: state.masterData.fetching,
  asterSuccess: state.masterData.success,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacManagerAction(data)),

  dispatchResetFinacUsersList: () => dispatch(resetFinacUsersList()),
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchResetAuthError: () => dispatch(resetAuthError()),

  dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),
  dispatchResetSession: () => dispatch(resetSession()),

  ///holiday calender
  dispatchResetMasterDataHolidayCalenderListing: () =>
    dispatch(resetHolidayCalenderList()),
  dispatchGetMasterDataHolidayCalenderAction: (
    data: GetHolidayCalenderPayloadType
  ) => dispatch(getMasterDataHolidayCalenderAction(data)),
    dispatchUserProfileData: (data: any) => dispatch(userProfileAction(data)),
  dispatchResetMasterSuccess: () => dispatch(resetMasterSuccess()),
  dispatchResetMasterError: () => dispatch(resetMasterError()),
  dispatchResetMasterMessage: () => dispatch(resetMasterMessage()),
  dispatchResetMasterStatusCode: () => dispatch(resetMasterStatusCode()),
  dispatchResetUserProfileAllData: () => dispatch(resetUserProfileAllData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ApplyLeaveModal);
